import responsive from './responsive';
import spacing from './spacing';
import fonts from './fonts';

export const fontSize = {
    'Mobile': 18,
    'Desktop': 26
}
export const linkGutter = {
    'Mobile': `${15/fontSize.Mobile}rem`,
    'AfterMobile': `${27/fontSize.Desktop}rem`
};
export const enum directions {
    top = 1,
    bottom = 1 << 1,
    left = 1 << 2,
    right = 1 << 3,
    all = 1 | 1 << 1 | 1 << 2 | 1 << 3,
    sides = 1 << 2 | 1 << 3
};

const prefixed = (prefix: string, value: number, multi: number = 1, dir: directions = directions.sides) => ({
    [prefix ? `${prefix}Left` : 'left']:
        (dir & directions.left) === directions.left && value * multi || undefined,
    [prefix ? `${prefix}Right` : 'right']:
        (dir & directions.right) === directions.right && value * multi || undefined,
    [prefix ? `${prefix}Bottom` : 'bottom']:
        (dir & directions.bottom) === directions.bottom && value * multi || undefined,
    [prefix ? `${prefix}Top` : 'top']:
        (dir & directions.top) === directions.top && value * multi || undefined
});

export default {
    'Body': {
        position: 'relative',
        width: '100%',
        height: '100%',
        ...fonts.ExcelsiorLT,
        lineHeight: '1.27',
        color: 'black',
        [responsive.Mobile]: {
            fontSize: fontSize.Mobile
        },
        [responsive.AfterMobile]: {
            fontSize: fontSize.Desktop
        }
    },
    'PaddingGutter': (multi: number = 1, dir: directions = directions.sides) => ({
        [responsive.Mobile]: prefixed('padding', spacing.Gutter.Mobile, multi, dir),
        [responsive.AfterMobile]: prefixed('padding', spacing.Gutter.Desktop, multi, dir)
    }),
    'MarginGutter': (multi: number = 1, dir: directions = directions.sides) => ({
        [responsive.Mobile]: prefixed('margin', spacing.Gutter.Mobile, multi, dir),
        [responsive.AfterMobile]: prefixed('margin', spacing.Gutter.Desktop, multi, dir)
    }),
    'PostionGutter': (multi: number = 1, dir: directions = directions.sides) => ({
        [responsive.Mobile]: prefixed('', spacing.Gutter.Mobile, multi, dir),
        [responsive.AfterMobile]: prefixed('', spacing.Gutter.Desktop, multi, dir)
    }),
}


// WEBPACK FOOTER //
// ./src/Constants/stylesheet.ts